const protocolToExchange = (protocol: string): string => {
  switch (protocol) {
  case 'uniswapV2': return 'uniswap';
  case 'sushiswapV2': return 'sushiswap';
  case 'pancake': return 'pancakeswap';
  default: return protocol;
  }
};

export { protocolToExchange };